import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import ImageList, { type ImageListOwnProps } from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import { memo } from 'react';

import { useBreakpoint } from '../../hooks/useBreakpoint/useBreakpoint';
import { MediaItem } from '../MediaItem/MediaItem';

export const MasonryMediaGallery = memo(function MasonryMediaGallery({
  media,
  onSelect,
  isLoading,
  variant,
}: {
  media: {
    src: string;
    alt: string;
  }[];
  isLoading?: boolean;
  onSelect: (src: string) => void;
  variant: ImageListOwnProps['variant'];
}) {
  const { isMobile } = useBreakpoint();

  return (
    <>
      <ImageList variant={variant} cols={isMobile ? 2 : 3} gap={isMobile ? 8 : 16}>
        {media.map(({ src, alt }, index) => (
          <ImageListItem key={src + index}>
            <MediaItem
              media={src}
              alt={alt}
              handleSelect={onSelect}
              slotProps={{
                image: {
                  minHeight: '200px',
                  rounded: false,
                  sx: {
                    cursor: 'pointer',
                  },
                  zoomOnHover: true,
                },
                video: {
                  autoPlay: true,
                  controls: true,
                  loop: true,
                  muted: true,
                  playsInline: true,
                  sx: {
                    cursor: 'pointer',
                  },
                },
              }}
            />
          </ImageListItem>
        ))}
      </ImageList>
      {isLoading ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            my: 4,
          }}
        >
          <CircularProgress />
        </Box>
      ) : null}
    </>
  );
});
